import instance from "./index";

const normalizeTeam = (team) => ({
  ...team,
  teamId: team?.teamId ?? team?.TeamId ?? team?.Id ?? team?.id ?? null,
  teamName: team?.teamName ?? team?.Team_Name ?? team?.name ?? "",
  projectId: team?.projectId ?? team?.ProjectId ?? team?.project_id ?? null,
  projectName:
    team?.projectName ??
    team?.Project_Name ??
    team?.project?.projectName ??
    team?.project?.Project_Name ??
    team?.project?.name ??
    "",
  clientId:
    team?.clientId ??
    team?.ClientId ??
    team?.client_id ??
    team?.client?.clientId ??
    team?.client?.ClientId ??
    team?.client?.id ??
    null,
  clientName:
    team?.clientName ??
    team?.Client_Name ??
    team?.client?.clientName ??
    team?.client?.Client_Name ??
    team?.client?.name ??
    "",
});

export const getAllTeams = async () => {
  try {
    const response = await instance.get("/team");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeTeam);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load teams";
    throw new Error(message);
  }
};

const normalizeId = (value) => {
  if (value === undefined || value === null || value === "") return null;

  const id = Number(value);
  return Number.isFinite(id) ? id : null;
};

export const createTeam = async ({ teamName, projectId, clientId }) => {
  const normalizedProjectId = normalizeId(projectId);
  const normalizedClientId = normalizeId(clientId);
  const payload = {
    teamName: String(teamName ?? "").trim(),
  };

  if (Number.isFinite(normalizedProjectId)) {
    payload.projectId = normalizedProjectId;
  } else if (Number.isFinite(normalizedClientId)) {
    payload.clientId = normalizedClientId;
  }

  if (!payload.teamName) {
    throw new Error("Team name is required");
  }

  if (!payload.projectId && !payload.clientId) {
    throw new Error("Client is required");
  }

  try {
    const response = await instance.post("/team", payload);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create team";
    throw new Error(message);
  }
};

export const updateTeam = async ({ teamId, teamName, projectId }) => {
  const normalizedProjectId = normalizeId(projectId);
  const payload = {
    teamName: String(teamName ?? "").trim(),
  };

  if (Number.isFinite(normalizedProjectId)) {
    payload.projectId = normalizedProjectId;
  }

  if (!teamId) {
    throw new Error("Team is required");
  }

  if (!payload.teamName) {
    throw new Error("Team name is required");
  }

  if (!payload.projectId) {
    throw new Error("Project is required");
  }

  try {
    const response = await instance.put(`/team/${teamId}`, payload);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update team";
    throw new Error(message);
  }
};


